import { StyleFn } from './index'

export type StylesKeys = 'wrapper' | 'innerWrapper'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  wrapper: StyleFn
  innerWrapper: StyleFn
}

export const defaultStyles: Styles = {
  wrapper: () => ({
    '--rw-gap': '1em',
    '--rw-columns': '250px 160px 350px 50px 1fr',
    '--rw-areas': "'det btn wav tim xtr'",
    '--rw-width': '90vw',
    '--rw-max-width': '1460px',
    backgroundColor: 'rgba(11, 10, 37, 1)',
    padding: '0.94em',
    color: 'white',
  }),
  innerWrapper: () => ({
    display: 'grid',
    gridTemplateColumns: 'var(--rw-columns, 250px 160px 350px 50px 1fr)',
    gridTemplateAreas: 'var(--rw-areas)',
    gridGap: 'var(--rw-gap, 1em)',
    width: 'var(--rw-width, 90vw)',
    maxWidth: 'var(--rw-max-width, 1460px)',
    margin: '0 auto',
    alignItems: 'center',
  }),
}
